import React, { useState, useEffect } from "react";

export default function LookAndFeelPreferences({ register, errors }) {
  const fieldName = "lookAndFeelPreferences";
  const [showNewChoice, setShowNewChoice] = useState(false);

  useEffect(() => {
    register(`${fieldName}.other`); // Register the field outside the render method
  }, [register]);

  const options = [
    {
      value: "leaveToTeam",
      label: "Not really, I'm happy to leave it to your design team",
    },
    {
      value: "moreDetail",
      label: "Yes, and I'd like to go into some more detail about it",
    },
    { value: "haveDesigns", label: "I've already got designs drawn up" },
  ];

  return (
    <fieldset>
      <legend className="wdc-field-label">
        Do you have any opinions about the look &amp; feel of your site?
      </legend>
      <div className="space-y-2.5">
        {options.map((item) => (
          <label
            key={item.value}
            htmlFor={`${fieldName}-${item.value}`}
            className="wdc-option"
          >
            <input
              id={`${fieldName}-${item.value}`}
              type="radio"
              className="wdc-check"
              value={item.value}
              {...register(`${fieldName}.choice`, { required: false })}
            />
            <span className="wdc-option-label">{item.label}</span>
          </label>
        ))}

        <label htmlFor={`${fieldName}-other`} className="wdc-option">
          <input
            id={`${fieldName}-other`}
            type="checkbox"
            className="wdc-check"
            value="other"
            onChange={(e) => setShowNewChoice(e.target.checked)}
          />
          <span className="wdc-option-label">Add new choice</span>
        </label>

        {errors[fieldName] && (
          <span className="wdc-error">This field is required</span>
        )}
      </div>

      {showNewChoice && (
        <div className="mt-3">
          <input
            type="text"
            placeholder="Enter new choice"
            className="wdc-field"
            {...register(`${fieldName}.otherText`)}
          />
        </div>
      )}
    </fieldset>
  );
}
